import $ from "jquery";
import "jquery-validation";
import "form-serializer";

class Modal {
  constructor() {
    this.init();
  }

  init() {
    this.body = $("body");
    this.addEvents();
    this.validation();
  }

  addEvents() {
    $(".field input, .field textarea").each((index, el) => {
      $(el).val() != "" && $(el).parent().addClass("selected");
    });

    // Signup
    $(".button--request").on("click", (e) => {
      e.preventDefault();
      this.body.addClass("hasSignup");

      if (!window.rendered) {
        window.renderRecaptcha(
          "signup-recaptcha",
          this.signupCallback,
          this.expiredSignupCallback
        );
        window.rendered = true;
      }
    });

    // Contact
    $(".button--contact").on("click", (e) => {
      e.preventDefault();
      this.body.addClass("hasContact");

      if (!window.rendered) {
        window.renderRecaptcha(
          "contact-recaptcha",
          this.contactCallback,
          this.expiredContactCallback
        );
        window.rendered = true;
      }
    });

    $(".close-all-modals").on("click", (e) => {
      e.preventDefault();
      this.body.removeClass("hasSignup hasContact hasSuccess");
    });

    $(".modal").on("click", (e) => {
      //e.preventDefault();
      if (
        e.target == $(".modal--signup")[0] ||
        e.target == $(".modal--contact")[0]
      ) {
        this.body.removeClass("hasSignup hasContact hasSuccess");
      }
    });

    $(".field input, .field textarea").on("focus", (e) => {
      $(e.currentTarget).parent().addClass("selected");
    });

    $(".field input, .field textarea").on("blur", (e) => {
      $(e.currentTarget).val() == "" &&
        $(e.currentTarget).parent().removeClass("selected");
    });

    // Contact submit

    $("#contactSubmit").on("click", (e) => {
      e.preventDefault();

      if ($("#contactForm input, #contactForm textarea").valid()) {
        this.contactSubmit();
      }
    });

    // Capture GA tag
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams.get("tag"));
    if (urlParams.get("tag") || sessionStorage.getItem("tag")) {
      sessionStorage.setItem("tag", "GA");
      document.getElementById("signupFormTag").value = "GA";
    }

    // Signup submit

    $("#signupSubmit").on("click", (e) => {
      e.preventDefault();

      if ($(`#signup input, #signup textarea`).valid()) {
        $("#signupSubmitLabel").html(
          '<i class="fas fa-fw fa-spinner fa-spin"></i> Submitting...'
        );

        var formData = $("#signupForm").serializeObject();
        formData["g-recaptcha-response"] =
          window.recaptchaResponse("signup-recaptcha");

        $.ajax({
          type: "POST",
          url: Syngency.signup_form_url,
          data: JSON.stringify(formData),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        })
          .done(function () {
            $("body").addClass("hasSuccess");
            $("#signupForm")[0].reset();
            $("#signupSubmitLabel").html("Submit");
            window.resetRecaptcha("signup-recaptcha");
          })
          .fail(function (error) {
            console.error(error);
            var errorMessage =
              "We are unable to process your submission at this time. Please email team@syngency.com.";
            $(".signup__error").html(errorMessage).removeClass("hidden");
            window.resetRecaptcha("signup-recaptcha");
          });
      } else {
        $(".signup__error").addClass("invalid");
      }
    });
  } // addEvents

  validation() {
    $("#contactForm").validate({});

    $("#signupForm").validate({
      errorPlacement: function (error, element) {},
    });
  }

  contactSubmit() {
    $(".contact__form .button--submit").addClass("sending");
    var formData = $("#contactForm").serializeObject();
    formData["g-recaptcha-response"] =
      window.recaptchaResponse("contact-recaptcha");

    $.ajax({
      type: "POST",
      url: Syngency.contact_form_url,
      data: JSON.stringify(formData),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      context: this,
    })
      .done(function (done) {
        if (done.success) {
          $("#contactForm").trigger("reset");
          this.body.addClass("hasSuccess");
          window.resetRecaptcha("contact-recaptcha");
        } else {
          $(".contact__error").html(json.message);
          window.resetRecaptcha("contact-recaptcha");
        }
      })
      .fail(function () {
        $(".contact__error").html(json.message);
        window.resetRecaptcha("contact-recaptcha");
      })
      .always(function () {
        $(".contact__form .button--submit").removeClass("sending");
      });
  }

  contactCallback() {
    $(".contact__error").html("").addClass("hidden");
    $("#contactSubmit").removeClass("sending");
  }

  signupCallback() {
    $(".signup__error").html("").addClass("hidden");
  }

  expiredContactCallback() {}
  expiredSignupCallback() {}
  removeEvents() {}
  destroy() {}
}

module.exports = Modal;
